export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/okmaia.ia',
  linkedin: 'https://www.linkedin.com/company/okmaia',
  github: 'https://github.com/OkMaia',
};

export const SAME_AS_LINKS = [
  SOCIAL_LINKS.instagram,
  SOCIAL_LINKS.linkedin,
  SOCIAL_LINKS.github,
];
